import { Component, OnInit,  OnDestroy, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject, SubscriptionLike } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { CommonService } from 'src/app/services/common.service';
import { DeleteBoxComponent } from '../../delete-box/delete-box.component'; 
import { AutoComplete } from 'primeng/autocomplete';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileData, FileService } from 'src/app/services/file.service';
import { Document_Upload_File } from '../../../models/common';

@Component({
  selector: 'app-email-compose',
  templateUrl: './email-compose.component.html',
  styleUrls: ['./email-compose.component.scss']
})
export class EmailComposeComponent implements OnInit, OnDestroy {

  subUploadMultiFiles: SubscriptionLike;
  subGetData: SubscriptionLike;
  subGetData1: SubscriptionLike;
  subGetData2: SubscriptionLike;
  subGetData3: SubscriptionLike;
  subGetData4: SubscriptionLike;
  subGetData5: SubscriptionLike;
  subInsertDataPost: SubscriptionLike;

  @ViewChild('FileInput') fileInput;
  @ViewChild(AutoComplete) private autoComplete: AutoComplete;
  @Input() public Content: any;
  content: any;
  ApplicationID: string;
  ModuleID: string;
  SubModule:string;
  PKRRFMsgID:string;
  msgType: string;
  mailFolder: string;
  msgObj: any;
  ComposeMail: UntypedFormGroup
  currentUserEmail = localStorage.getItem("_idue");
  emailTemplates: any[] = [];
  templateInfo: TemplateInfo = new TemplateInfo();
  overlayTitle: string = "Compose Email";
  originalEmailBody = "";
  dateFormat = localStorage.getItem("_Dateformate") ?? 'DD MMM YYYY';
  datetimeFormat = this.dateFormat + ' ' + localStorage.getItem("_Timeformate");
  timeFormat: any = localStorage.getItem("_Timeformate");
  action: Subject<any> = new Subject();
  document_attach_list: Document_Upload_File[] = [];
  FileID: any;
  FileName: any;
  NavigateFrom : string;
  //@Output() RefreshCount: EventEmitter<any> = new EventEmitter();
  
  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    suffix: '.min',
    statusbar: false,
    //toolbar: false,
    menubar: false,
    height: 'calc(100vh - 340px) !important',
    paste_data_images: true
  };


  //fileToUpload: File;
  allowedFileTypes: any;
  allowedFileSize: any;
  uploadedFileArray: FileData[] = [];
  fileName: string;

  constructor(
    public apiService: ApidataRequestService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private readonly fileService: FileService,
    private datePipe: DatePipe,
    private commonService: CommonService,
  ) { }

  ngOnDestroy(): void {
    if (this.subGetData) this.subGetData.unsubscribe();
    if (this.subGetData5) this.subGetData5.unsubscribe();
    if (this.subGetData4) this.subGetData4.unsubscribe();
    if (this.subGetData3) this.subGetData3.unsubscribe();
    if (this.subGetData2) this.subGetData2.unsubscribe();
    if (this.subGetData1) this.subGetData1.unsubscribe();
    if (this.subUploadMultiFiles)
      this.subUploadMultiFiles.unsubscribe();
    if (this.subInsertDataPost)
      this.subInsertDataPost.unsubscribe();
  }
  mails: any[];
  filteredMails: any[];
  ngOnInit(): void {
    this.ApplicationID = this.Content.content.ApplicationID;
    this.ModuleID = this.Content.content.ModuleID; 
    this.SubModule= this.Content.content.SubModule; 
    this.msgType = this.Content.content.MailType;
    this.NavigateFrom = this.Content.content.SendFrom;

    if(this.NavigateFrom == null || this.NavigateFrom == undefined){
      this.NavigateFrom = 'Correspondence';
    }

    if(this.msgType == "reply"|| this.msgType == "reply-all" || this.msgType == "forward") 
    {
      this.PKRRFMsgID= this.Content.content.PKRRFMsgID;
    }
    this.mailFolder = this.Content.content.MailFolder;
    this.overlayTitle = this.msgType == "draft" ? "Compose" :
      this.msgType == "reply" ? "Reply" :
        this.msgType == "reply-all" ? "Reply All" :
          this.msgType == "forward" ? "Forward" : "Compose Email";

    this.ComposeMail = new UntypedFormGroup({
      MsgID: new UntypedFormControl(null),
      ApplicationID: new UntypedFormControl(this.ApplicationID),
      ModuleID: new UntypedFormControl(this.ModuleID),
      SubModule: new UntypedFormControl(this.SubModule),
      PKRRFMsgID: new UntypedFormControl(null),
      From: new UntypedFormControl(""),
      To: new UntypedFormControl([], [Validators.required]),
      CC: new UntypedFormControl([]),
      BCC: new UntypedFormControl([]),
      Subject: new UntypedFormControl("", [Validators.required, Validators.maxLength(1000)]),
      Attachments: new UntypedFormControl([]),
      IsHighImp: new UntypedFormControl(false),
      MailBody: new UntypedFormControl(""),
      Folder: new UntypedFormControl("I"),
      TemplateID: new UntypedFormControl(""),
      HasFileChange: new UntypedFormControl(false),
      IsReplyMail: new UntypedFormControl(false),
      IsFwdMail: new UntypedFormControl(false)
    });
    this.getTeamMembersMails();

    if (this.msgType != "new") {
      this.msgObj = this.Content.content.EmailMsgObj
      this.getMessage(this.msgObj.MsgID);
    }    
    this.getEmailTemplates();
    this.getFileConfig();
  }

  getTeamMembersMails() {
    this.subGetData = this.apiService.getData("api/Correspondence/GetAutoCompleteMails?SubModule=" + this.SubModule).subscribe(result => {
      this.mails = result.Data;
    })
  }

  addToSuggestionList(event, etype: 'To' | 'CC' | 'BCC') {
    let email ="";
    if (event.target.value.indexOf(',') > -1) {
       email = event.target.value.split(',')[0];
    }
    else if (event.target.value.indexOf(';') > -1) {
       email = event.target.value.split(';')[0];
    }
    else if (event.target.value!="" && event.target.value.indexOf(' ') > -1) {
      email = event.target.value.split(' ')[0];
    }
      let emails = this.ComposeMail.get(etype)?.value;
      if (email!=null && email!= "" && email!=undefined) {//&& this.commonService.validateEmail(email)
      if (emails == null || emails.length == 0)
        emails.push({ UserName: email, EmailAddress: email });
      else {
        let fEmail = emails.find(x => x.EmailAddress.toLowerCase() == email.toLowerCase());
        if (fEmail == null || fEmail == undefined)
          emails.push({ UserName: email, EmailAddress: email });
      }
      event.target.value = '';
    }       
  }

  CheckValidateEmail(event, etype: 'To' | 'CC' | 'BCC') {
    if (event.target.value != "" && event.target.value.indexOf('@') >-1) {
      let email = event.target.value;
    //   if (event.target.value.indexOf(',') === -1 && event.target.value.indexOf(';') === -1
    //   && event.target.value.indexOf(' ') === -1
    //   ) {
    //     email = email+";";
    //  }
     
      let emails = this.ComposeMail.get(etype)?.value;
     // if (this.commonService.validateEmail(email)) {
      if (emails == null || emails.length == 0)
        emails.push({ UserName: email, EmailAddress: email });
      else {
        let fEmail = emails.find(x => x.EmailAddress.toLowerCase() == email.toLowerCase());
        if (fEmail == null || fEmail == undefined)
          emails.push({ UserName: email, EmailAddress: email });
      }
   // }     
      event.target.value = '';
    }
}

  onFocus() {
    this.autoComplete.show();
}

  
  filterMail(event) {
    let filtered: any[] = [];      
    let query = event.query;
    for (let i = 0; i < this.mails.length; i++) {
      let mail = this.mails[i];
      if (mail.EmailAddress.toLowerCase().indexOf(query.toLowerCase()) == 0) { filtered.push(mail); }
    }
    this.filteredMails = filtered;
  }

   
  getFileConfig() {
    this.allowedFileTypes = "PDF, DOC, DOCX, XLS, XLSX, TXT, PPTX, PPT, PNG, JPEG, JPG";
    this.allowedFileSize = 25;
  }

  ExistedAttachments: any;
  getMessage(MessageID: any) {
    this.subGetData2 = this.apiService.getData("api/Correspondence/GetMailInfo?MsgID=" + MessageID).subscribe(result => {
      if (result.Status) {
 
       // let toArr = result.Data.To.split(',');
       
          let OutgoingEmailID = result.Data.OutgoingEmailID;
          this.ComposeMail.patchValue({
            MsgID: this.msgType == "draft"? this.msgObj.MsgID:null,
            ApplicationID: this.ApplicationID,
            ModuleID: this.ModuleID,    
            SubModule: this.SubModule,      
            From: result.Data.From,
          To: (result.Data.To == '' || result.Data.To == null) ? [] : result.Data.To.split(',').map(x => { return { UserName: x, EmailAddress: x }; }),
          CC: (result.Data.CC == '' || result.Data.CC == null) ? [] : result.Data.CC.split(',').map(x => { return { UserName: x, EmailAddress: x }; }),
          BCC: (result.Data.BCC == '' || result.Data.BCC == null) ? [] : result.Data.BCC.split(',').map(x => { return { UserName: x, EmailAddress: x }; }),
          Subject: result.Data.Subject,
          Attachments: result.Data.Attachments,
          IsHighImp: result.Data.IsHighImp,
          MailBody: result.Data.MsgBody,
          TemplateID: result.Data.TemplateID,
          IsReplyMail: result.Data.IsReplied,
          IsFwdMail: result.Data.IsForward,
          });

        if (this.msgType == "reply" || this.msgType == "reply-all") {
           
          if (this.mailFolder == "I") {

            if(this.msgType == "reply"){
              //23R1 Bug 212 start 
              let fromData:any = []; fromData.push({EmailAddress:this.ComposeMail.controls["From"].value, UserName:this.ComposeMail.controls["From"].value})
              this.ComposeMail.controls["To"].setValue(fromData);
              //23R1 Bug 212 end
            }
            if (this.msgType == "reply-all") {
              //23R1 Bug 212 start
              let fromEmail = this.ComposeMail.controls["From"].value;
              let toEmail = this.ComposeMail.controls["To"].value;
              //'To' field mails for reply all start
              toEmail.push({EmailAddress:fromEmail, UserName:fromEmail});
              toEmail = toEmail.filter(function( obj ) {
                return obj.EmailAddress !== OutgoingEmailID;
              });
              this.ComposeMail.controls["To"].setValue(toEmail);   
              //'To' field mails for reply all end      
              //23R1 Bug 212 end  
            }
          }
          this.ComposeMail.controls['Subject'].disable();
        }
        else {
          result.Data.Attachments.forEach(element => {
            this.uploadedFileArray.push({
              FileID: element.FileID,
              FileName: element.FileName,
              FileExt: element.FileExt,
              IsFromTemp: false,
              downloadUrl: serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + element.FileID
              //"api/File/download/main/" + element.FileID
            })
          });
        }
        if (this.msgType == "draft")
        {       
        this.PKRRFMsgID = result.PKRRFMsgID;  
        this.ComposeMail.controls["PKRRFMsgID"].setValue(this.PKRRFMsgID);       
        if(this.ComposeMail.controls["IsReplyMail"].value) {          
        this.ComposeMail.controls['Subject'].disable();
        }
      }
        if (this.msgType != "draft") {
        let appendDets = "<span><strong>From</strong>: " + this.msgObj.From + "</span><br/>";
        appendDets += "<span><strong>Sent</strong>: " + this.msgObj.MsgDateString + "</span><br/>";
        appendDets += "<span><strong>To</strong>: " + this.msgObj.To + "</span><br/>";
        appendDets += "<span><strong>Subject</strong>: " + this.msgObj.Subject + "</span><br/>";
        let emailThread = "<br/><br/><hr/>" + appendDets + this.ComposeMail.controls["MailBody"].value;//this.msgObj.MsgBody;
        this.ComposeMail.controls["MailBody"].setValue(emailThread)
        this.originalEmailBody = emailThread;
        }
      }
      else if (this.msgType != "draft") {
        this.ComposeMail.controls["MailBody"].setValue("");
      }
      if (this.msgType == "reply") {
        this.ComposeMail.controls["IsReplyMail"].setValue(true);
        this.ComposeMail.controls["CC"].setValue([]);
        this.ComposeMail.controls["BCC"].setValue([]);
        this.ComposeMail.controls["TemplateID"].setValue("");
        // this.ComposeMail.controls["Subject"].disable();
        this.ComposeMail.controls["Attachments"].setValue([]);
        // result.Data.Attachments = [];
      }
      if (this.msgType == "reply-all") {
        this.ComposeMail.controls["IsReplyMail"].setValue(true);
        this.ComposeMail.controls["TemplateID"].setValue("");
        // this.ComposeMail.controls["Subject"].disable();
        this.ComposeMail.controls["Attachments"].setValue([]);
        // result.Data.Attachments = [];
      }
      if (this.msgType == "forward") {
        this.ComposeMail.controls["IsFwdMail"].setValue(true);
        this.ComposeMail.controls["To"].setValue([]);
        this.ComposeMail.controls["CC"].setValue([]);
        this.ComposeMail.controls["BCC"].setValue([]);
        //this.ExistedAttachments = result.Data.Attachments;
      }      
    });
  }

  getEmailTemplates() {

    this.subGetData3 = this.apiService.getData("api/Correspondence/GetEmailTemplates?EmailTempID=" + this.Content.content?.EmailMsgObj?.TemplateID + "&ModuleID=" + this.ModuleID + "&ApplicationID=" + this.ApplicationID).subscribe(result => {
      if (result.Status && result.Data.length > 0) {
        this.emailTemplates = result.Data;
      } else {
        this.emailTemplates = [];
      }
    });
  }

  getTemplateInfo() {
    
    if (this.ComposeMail.controls["TemplateID"].value != "") {
      this.subGetData4 = this.apiService.getData("api/Correspondence/GetTemplateInfo?TemplateID=" + this.ComposeMail.controls["TemplateID"].value + "&ApplicationID=" + this.ApplicationID).subscribe(result => {
        if (result.Status) {
          this.templateInfo = result.Data;

          var template_TO = this.templateInfo.To == null ? [] : this.templateInfo.To.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          var template_CC = this.templateInfo.CC == null ? [] : this.templateInfo.CC.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          var template_BCC = this.templateInfo.BCC == null ? [] : this.templateInfo.BCC.split(',').map(x => { return { UserName: x, EmailAddress: x }; });
          this.ComposeMail.controls["To"].setValue(template_TO);//+ this.ComposeMail.controls["To"].value);
          this.ComposeMail.controls["CC"].setValue(template_CC);// + this.ComposeMail.controls["CC"].value);
          this.ComposeMail.controls["BCC"].setValue(template_BCC);// + this.ComposeMail.controls["BCC"].value);
          // this.ComposeMail.controls["Subject"].setValue(this.ComposeMail.controls["Subject"].value + " " + this.templateInfo.Subject ?? "");
          this.ComposeMail.controls["Subject"].setValue(this.templateInfo.Subject ?? "");

          // var existing_Mailbody = this.ComposeMail.controls["MailBody"].value;
          var existing_Mailbody = this.originalEmailBody;
          var concated_Mailbody = this.templateInfo.MailBody + existing_Mailbody;

          this.ComposeMail.controls["MailBody"].setValue(concated_Mailbody);
        } else {
          this.templateInfo = new TemplateInfo();
          this.ComposeMail.controls["To"].setValue([]);
          this.ComposeMail.controls["CC"].setValue([]);
          this.ComposeMail.controls["BCC"].setValue([]);
          this.ComposeMail.controls["Subject"].setValue("");
          this.ComposeMail.controls["MailBody"].setValue("");
        }
      });
    }
    else {
      if (this.msgType != "draft" && this.msgType != "new") {

      } else {
        this.templateInfo = new TemplateInfo();
        this.ComposeMail.controls["To"].setValue([]);
        this.ComposeMail.controls["CC"].setValue([]);
        this.ComposeMail.controls["BCC"].setValue([]);
        this.ComposeMail.controls["Subject"].setValue("");
        this.ComposeMail.controls["MailBody"].setValue("");
      }
    }
  }

  ValidateForm(): boolean {
    let isValid = true;
    
    var emailto =this.ComposeMail.get('To')?.value;// this.ComposeMail.controls['To'].value;
    var emailsub = this.ComposeMail.controls['Subject'].value;
    let message = "";
    if (emailto == null || emailto.length == 0) {
      message +="Enter at least one recipient in To field <br/>";
      isValid = false;
    }

    if (this.ComposeMail.controls['Subject'].hasError("required")) {
      message +="Please enter Subject <br/>";
      isValid = false;
    }
    if (this.ComposeMail.controls['Subject'].hasError("maxLength")) {
      message +="Length of Subject should not exceed 1000<br/>";
      isValid = false;      
    }

    var emailto = this.ComposeMail.controls['To'].value;     
      if (emailto != null && emailto.length > 0) {
      for (var i = 0; i < emailto.length; i++) {
        if (!this.commonService.validateEmail(emailto[i].EmailAddress.trim())) {
          message +='Email id "' + emailto[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }   

    var emailcc = this.ComposeMail.controls['CC'].value;
    if (emailcc != null && emailcc.length > 0) {
      for (var i = 0; i < emailcc.length; i++) {
        if (!this.commonService.validateEmail(emailcc[i].EmailAddress.trim())) {
          message +='Email id "' + emailcc[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }

    var emailbcc = this.ComposeMail.controls['BCC'].value;
    if (emailbcc != null && emailbcc.length > 0) {
      for (var i = 0; i < emailbcc.length; i++) {
        if (!this.commonService.validateEmail(emailbcc[i].EmailAddress.trim())) {
          message +='Email id "' + emailbcc[i].EmailAddress + '" is invalid. Please enter valid email id to send the email<br/>';
          isValid = false;
        }
      }
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);     
    }
    return isValid;
  }

  ValidateDraft(): boolean {
    let isValid = true;
    var err: any = [];

    if (!this.ComposeMail.controls['To']?.valid &&
      !this.ComposeMail.controls['Subject']?.valid &&
      this.ComposeMail.controls['MailBody'].value == "" &&
      this.ComposeMail.controls['CC'].value.length == 0 &&
      this.ComposeMail.controls['BCC'].value.length == 0 &&
      this.uploadedFileArray.length == 0 &&
      !this.ComposeMail.controls["IsHighImp"].value) {
      err.push("Enter data in at least one field");
      isValid = false;
      if (!isValid) {
        this.commonService.ValidationBanner(err);        
      }
      return isValid;
    }

    if (!isValid) {
      this.commonService.ValidationBanner(err);     
    }
    return isValid;
  }

  discard() {  
    const modalRef = this.modalService.open(DeleteBoxComponent, {backdrop: false
    })
    modalRef.componentInstance.Content= 
    {header:'Confirmation',
     heading: 'Confirmation', 
     custommessage: 'Are you sure you want to delete the selected Item?', 
     ProceedButtonName: "Delete", 
     TerminateButtonName: "Cancel" }
    modalRef.result.then((result) => {
      if(result=="okclick")
        {   
                
          this.modalRef.close();
          this.discardMail();
         
        }
    });

  }

  discardMail = () => {
    if (this.msgType == "draft") {
      let discardMsgId = this.ComposeMail.controls["MsgID"].value
      this.subGetData5 = this.apiService.getData("api/Correspondence/DeleteDraft?emailMsgID=" + discardMsgId).subscribe(result => {
        if (result.Status) {                           
          this.commonService.SuccessBanner(result.SuccessMessage); 
         
            
           this.modalRef.close();           
      
        //  this.RefreshCount.emit("");               
        } else {
          this.commonService.ValidationBanner(result.errMessage);         
        }
      })
    }
    else {      
      this.commonService.SuccessBanner("Email discarded successfully");  
      
          
      this.modalRef.close();    
     }
  }

  private validateFile(fileToUpload) {

    let isValidFile = true;
   // var err: any = [];
    let message = "";
    let fileType = fileToUpload?.name.substring(fileToUpload?.name.length - 4, fileToUpload.name.length);
    fileType = fileType?.toLowerCase();
    var filesize = fileToUpload.size;

    let fileExt = fileToUpload?.name.split('.').pop() as string;
    if (fileToUpload != null && (fileExt == 'exe'))
    {
      isValidFile = false;
      message += 'The system does not support .exe files. Please choose a different file format to save the details.';
    }
    else if (fileToUpload != null && (fileExt == 'crdownload'))
    {
      isValidFile = false;
      message += 'The system does not support .crdownload files. Please choose a different file format to save the details.';
    }
    else if (fileToUpload != null && ((filesize > 52428800))) {
     // Is5oMB = true;
     message +='Accepts maximum file size 50MB';

     }
    // // if (fileToUpload != null && fileToUpload.size > (this.allowedFileSize * 52428800)) {
    //   isValidFile = false;
  //}
    if (fileToUpload != null && fileToUpload.name != null && fileToUpload.name.length > 250) {
      isValidFile = false;
      message +='File name cannot be more than 250 characters <br/>';
  }

    // if (!isValidFile) {
    //   this.commonService.ValidationBanner(err);      
    // }
    return message;//isValidFile;
  }

  saveTempFiles(event: any) {
    
    var err: any = [];
    let msgF ="";
    var selectedFiles: File[] = event.target.files;
    const formData = new FormData();
    for (var i = 0; i < selectedFiles.length; i++) {
     let msg = this.validateFile(selectedFiles[i]);
      if(msg != "") 
      {
        if(err.indexOf(msg)==-1)
        {
        msgF+=msg;
        err.push(msg);
        }
        }
      else 
      {         
        formData.append(`files[${i}]`, selectedFiles[i]);
      }   
    }
    this.subUploadMultiFiles = this.fileService.uploadMultiFiles(formData, "").subscribe(
      (result: any) => {

        result.Data.forEach(element => {
          this.uploadedFileArray.push({
            FileID: element.FileID,
            FileName: element.FileName,
            FileExt: element.FileExt,
            IsFromTemp: true,
            downloadUrl: serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + element.FileID
            //"api/File/DownloadFile?type=temp" + "&id=" + element.FileID
          })
        });
        if (result.FileName && result.FileExt)
          this.fileName = result.FileName;
      },
      err => {
        this.commonService.ValidationBanner(err);       
      });
       if(msgF != "" && msgF.length > 0)
      this.commonService.ValidationBanner(msgF);   
  }

  removeFile(fileObj) {   
    this.uploadedFileArray.splice(this.uploadedFileArray.indexOf(fileObj), 1);
    if (this.msgType == "draft") {
      this.ComposeMail.controls["HasFileChange"].setValue(true);
    }
  }

  sendMail() {

    if (this.ValidateForm()) {
      if (this.msgType == "forward" || this.msgType == "new") {
        this.ComposeMail.controls["Attachments"].setValue(this.uploadedFileArray);
      }
      if (this.msgType == "reply" || this.msgType == "reply-all") {
        this.ComposeMail.controls["Attachments"].setValue(this.uploadedFileArray);
      }
      this.ComposeMail.controls["Folder"].setValue("O");
      this.emailStore();
    }
  }

  saveDraft() {
    if (this.ValidateDraft()) {
      this.ComposeMail.controls["Attachments"].setValue(this.uploadedFileArray);
      this.ComposeMail.controls["Folder"].setValue("D");
      this.emailStore();
    }
  }

  emailStore = () => {
     if(this.PKRRFMsgID !="" && this.PKRRFMsgID!=null && this.PKRRFMsgID!=undefined) 
     {      
         this.ComposeMail.controls["PKRRFMsgID"].setValue(this.PKRRFMsgID);
     }
    let FOrmData = this.ComposeMail.value;
    FOrmData["Subject"] = this.ComposeMail.controls["Subject"].value;
    FOrmData["To"] = this.ComposeMail.controls["To"].value != null ? ((this.ComposeMail.controls["To"].value).map(x => { return x.EmailAddress })).toString() : "";
    FOrmData["CC"] = this.ComposeMail.controls["CC"].value != null ? ((this.ComposeMail.controls["CC"].value).map(x => { return x.EmailAddress })).toString() : "";
    FOrmData["BCC"] = this.ComposeMail.controls["BCC"].value != null ? ((this.ComposeMail.controls["BCC"].value).map(x => { return x.EmailAddress })).toString() : "";   
    this.subInsertDataPost = this.apiService.InsertDataPost("api/Correspondence/SaveOrSendEmail/", FOrmData).subscribe(result => {
      if (result.Status) {     
        this.commonService.SuccessBanner(result.SuccessMessage);  
       
          
        this.modalRef.close();   
      }
      else {
        var err: any = [];
        err.push(result.errMessage);
        this.commonService.ValidationBanner(err);       
      }
    });
  }

  // downloadFile(ID) {
  //   let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
  //   window.open(url);  
  // }

  cancel(){
    this.modalRef.close();   
  }

}

export class TemplateInfo {
  public TemplateID: string
  public To: string
  public CC: string
  public BCC: string
  public Subject: string
  public MailBody: string
}
